exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".instant-confirmation-control{align-items:start;padding-top:12px}", ""]);

// exports
